import { format } from "date-fns/format";
import { parse } from "date-fns/parse";

/** Local calendar `yyyy-MM-dd` string (round-trips with {@link parseLocalDate}). */
export function getLocalDate(date: Date): string {
  return format(date, "yyyy-MM-dd");
}

export function parseLocalDate(dateStr: string): Date {
  return parse(dateStr, "yyyy-MM-dd", new Date());
}
